import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {useHistory} from 'react-router-dom';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import ScanInfoWindow from './components/ScanInfoWindow';
import {useParams} from "react-router-dom";
import ScanInfoWindowAsset from './components/ScanInfoWindowAsset';
import {JWT} from "../../constants/local-storage";
import SplitScreenSelector from './components/SplitScreenSelector';
import ScanNavigator from './components/ScanNavigator';
import FacilityForagerDocuments from "./components/FacilityForagerDocuments";
import GiraffeViewer from '../../pages/scanningvendors/components/GiraffeViewer';

import MobileFacility from './mobile/MobileFacility';

window.__assetTestCallback = function () {
  alert("🔥 Asset clicked – drawer would open here");
};

export default function Facility(props){
	
	const globalState = useContext(store);
	const history = useHistory();
	
	const refScreenLeft = useRef(null);
	const refScreenRight = useRef(null);
	
	const DISPLAY_SCAN = "SCAN";
	const DISPLAY_PHOTO = "PHOTO";

	const [displayMode, setDisplayMode] = useState(DISPLAY_PHOTO);
	
	
	const DEFAULT_WARNING = "NO PHOTO OR SCAN AVAILABLE";
	const WARNING_SCAN = "NO SCAN AVAILABLE";
	
	const [infoBoxId, setInfoBoxId] = useState("");
	const [infoBoxDisplay, setInfoBoxDisplay] = useState(false);
	const [infoBoxDisplayAsset, setInfoBoxDisplayAsset] = useState(false);
	const [scanUrl, setScanUrl] = useState("");
	const [isScanDisplay, setIsScanDisplay] = useState(false);
	const [displayAssetButton, setDisplayAssetButton] = useState("none");
	
	const [photoSource, setPhotoSource] = useState();
	const [photoMarginTop, setPhotoMarginTop] = useState("60px");
	const [photoMarginLeft, setPhotoMarginLeft] = useState("60px");
	const [warningDisplay, setWarningDisplay] = useState("none");
	const [warningText, setWarningText] = useState(DEFAULT_WARNING);
	const [displaySplitScreenSelector, setDisplaySplitScreenSelector] = useState("none");
	const [displayPopOutDocuments, setDisplayPopOutDocuments] = useState(false);
	const [aiDrawerVisible, setAiDrawerVisible] = useState(false);
	
	const id = useParams()["id"];
	const DIRECTION_UP = "DIRECTION_UP";
	const DIRECTION_DOWN = "DIRECTION_DOWN";
	const [facilityName, setFacilityName] = useState("");
	const [facilityCode, setFacilityCode] = useState("");
	
	const refAssetButton = useRef(null);

	useEffect(() => {
		
	  let host = window.location.origin;

	  if (functions.getIsDemoSystem()) {
	    setDisplaySplitScreenSelector("flex");
	  }

	  setInfoBoxId(id);
	  functions.getObjectFromAjax(
	    "/resolutionsoftwareplatform/facility?id=" + id,
	    null,
	    populateFrameSource
	  );

	  // ONLY open if not already open
	  if (!infoBoxDisplay) {
	    const timer = setTimeout(() => {
	      setInfoBoxDisplay(true);
	    }, 500);

	    return () => clearTimeout(timer);
	  }

	}, [id]); // 🔥 NOT infoBoxDisplay

	
	
	const photoStyle = {
 		display:"flex",
 		position:"fixed",
 		width:"100%",
 		height:"100vh",
 		left:"0px",
 		top:"0px"
 	};
 	
 	const warningStyle = {
 		display:warningDisplay,
 		position:"fixed",
 		top:"50vh",
 		left:"calc(50vw - 150px)",
 		backgroundColor:"black",
 		borderRadius:"5px",
 		height:"40px",
 		width:"300px",
 		color:"white",
 		alignItems:"center",
 		justifyContent:"space-around",
 		fontSize:"14px"
 	};

	const splitPaneContainer = {
		display:"flex",
		width:"100%",
		height:"100%"
	};
	
	const splitPane = {
		display:"flex",
		height:"100vh"
	};
	
	const captureClick = (e) => {
		alert("Clicked");
	};
	
	const populateFrameSource = (facility) => {
		if(facility.singleBuilding === false){
			history.push("/site/" + facility.id);
		}
		else{
			setFacilityName(facility.name);
			setFacilityCode(facility.code);
			if(facility.scanUrl === null || facility.scanUrl === ''){
				setIsScanDisplay(false);
				if(facility.photoFile != null && facility.photoFile != ''){
					try{
						loadPhoto(globalState.state.client.resourceFolderUrl + "/buildingphotos/" + facility.code + "/" + facility.photoFile);
					}
					catch(e){
						setWarningText(DEFAULT_WARNING);
						setWarningDisplay("flex");
					}
				}
				else{
					setWarningText(DEFAULT_WARNING);
						setWarningDisplay("flex");
				}
			}
			else{
				setIsScanDisplay(true);
				setDisplayMode(DISPLAY_SCAN);
				setScanUrl(facility.scanUrl);
			}
		}
	};
	
	const switchScan = (url) => {

		setScanUrl(url);
		    setDisplayMode(DISPLAY_SCAN);
		    setIsScanDisplay(true);
	};
	
	const loadPhoto= (imageUrl) => {
		fetch(imageUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    }).then(result => result.blob())
	    .then(result => {
	    	if(result.size > 1000){
	    		
				setPhotoSource(URL.createObjectURL(result));

				setDisplayMode(DISPLAY_PHOTO);

				setIsScanDisplay(false);
	    	}
	    	else{
	    		setWarningText(DEFAULT_WARNING);
					setWarningDisplay("flex");
	    	}
	    });
	};
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	backgroundColor:GREY_BACKGROUND
  };
  
 
 	const frameStyle = {
 		display:"flex",
 		marginTop:"0px",
 		marginLeft:"60px",
 		width:"calc(100% - 60px)",
 		height:"calc(100vh - 0px)"
 	};
 	
 	
 	
 	const assetButton = {
 		display:displayAssetButton,
 		position:"fixed",
 		left:"500px",
 		top:"350px",
 		height:"30px",
 		width:"150px",
 		alignItems:"center",
 		justifyContent:"space-around",
 		cursor:"pointer",
 		backgroundColor:"darkred",
 		color:"white",
 		fontSize:"14px",
 		boxShadow:'0 3px 6px rgba(0,0,0,0.4), 0 3px 6px rgba(0,0,0,0.4)',
 		borderRadius:"15px"
 	};
 	
 	const handleAssetButtonClick = () => {
 		setInfoBoxDisplayAsset(true);
 	};
 	
 	const planImage = {
		width:"2000px",
		height:"1000px"
	};
	
	
	const closeDocuments = () => {
		setDisplayPopOutDocuments(false);
	};
	
	
	const goDocuments = () => {
			setDisplayPopOutDocuments(!displayPopOutDocuments);
		};
		
		
		//--------------------------------------------------------
		// Mobile / Tablet
		//--------------------------------------------------------

		const isMobile =
		    window.innerWidth <= 768;

		const isTablet =
		    window.innerWidth > 768
		    &&
		    window.innerWidth <= 1200;

		const useResponsiveFacility =
		    isMobile
		    ||
		    isTablet;


	
	if(useResponsiveFacility)
	{
	    return (
	        <MobileFacility
	            id={id}
	            facilityName={facilityName}
	            facilityCode={facilityCode}
	            displayMode={displayMode}
	            scanUrl={scanUrl}
	            photoSource={photoSource}
	        />
	    );
	}
	
	return (
			<div style={thisContainer}>
				<Header transitionHide={true}/>
				<LeftMenu/>
				
				<div style={splitPaneContainer}>
				<div
				    style={{ ...splitPane, width: "100%" }}
				    ref={refScreenLeft}
				>

				    {displayMode === DISPLAY_SCAN &&

				        <GiraffeViewer
				            url={scanUrl}
				            onHotspotClick={captureClick}
				            aiDrawerVisible={aiDrawerVisible}
				            setAiDrawerVisible={setAiDrawerVisible}
				        />

				    }

				    {displayMode === DISPLAY_PHOTO && photoSource &&

				        <img
				            src={photoSource}
				            style={photoStyle}
				            alt=""
				        />

				    }

				</div>
					<div style={{...splitPane, width:'0%'}} ref={refScreenRight} >
						<iframe src="../matrixplan.png" style={frameStyle} frameborder='no'/>
					</div>
				</div>
				<div style={warningStyle}>
					{warningText}
				</div>
				<ScanInfoWindow
					id={infoBoxId}
					infoBoxDisplay={infoBoxDisplay}
					setInfoBoxDisplay={setInfoBoxDisplay}
					onOpenForge={props.onOpenForge}
					goDocuments={goDocuments}
					aiDrawerVisible={aiDrawerVisible}
					setAiDrawerVisible={setAiDrawerVisible}
				>
				</ScanInfoWindow>
				{/*<ScanInfoWindowAsset
					id="1"
					infoBoxDisplay={infoBoxDisplayAsset}
					setInfoBoxDisplay={setInfoBoxDisplayAsset}
				>
				</ScanInfoWindowAsset>*/}
				<div style={assetButton} ref={refAssetButton} onClick={handleAssetButtonClick}>
					Asset Info
				</div>
				<SplitScreenSelector
					id="facilitypage"
					screen1Label="View Scan"
					screen1Ref={refScreenLeft}
					screen2Label='View Layout'
					screen2Ref={refScreenRight}
					displayFlag={displaySplitScreenSelector}
				/>
				{isScanDisplay &&

				    <ScanNavigator
				        buildingId={id}
				        switchScan={switchScan}
						aiDrawerVisible={aiDrawerVisible}
						setAiDrawerVisible={setAiDrawerVisible}
				    />
				}
				<FacilityForagerDocuments
				    displayFlag={displayPopOutDocuments}
				    closeFunction={closeDocuments}
				    buildingId={parseInt(id)}
				    buildingName={facilityName}
					buildingCode={facilityCode}
				/>
			</div>
	);
}